import { major, minVersion, satisfies, subset, valid, validRange } from 'semver';

export function fulfillsVersionRange({
  version,
  acceptableVersions,
  canBeLatest,
}: {
  version: string;
  acceptableVersions: string;
  canBeLatest: boolean;
}): boolean {
  if (version === 'latest') {
    return canBeLatest;
  }

  let cleanedUserVersion, isRange;

  if (valid(version)) {
    cleanedUserVersion = valid(version);
    isRange = false;
  } else if (validRange(version)) {
    cleanedUserVersion = validRange(version);
    isRange = true;
  }

  return (
    // If the given version is a bogus format, this will still be undefined and we'll automatically reject it
    !!cleanedUserVersion &&
    (isRange ? subset(cleanedUserVersion, acceptableVersions) : satisfies(cleanedUserVersion, acceptableVersions))
  );
}

/**
 * Get a version bucket string for analytics.
 * Returns format like "15.x" for versions >= minimumMajor, or "<{minimumMajor}.0.0" otherwise.
 */
export function getVersionBucket(version: string | undefined, minimumMajor: number): string {
  if (!version) {
    return 'none';
  }

  try {
    const minVer = minVersion(version);
    if (!minVer) {
      return 'invalid';
    }
    const majorVersion = major(minVer);
    if (majorVersion >= minimumMajor) {
      return `${majorVersion}.x`;
    }
    return `<${minimumMajor}.0.0`;
  } catch {
    return 'unknown';
  }
}
